import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { GlobalLayout } from 'client-app/layouts/global-layout';
import { ClientOrdersListPage } from 'client-app/pages/client-orders';
import { Login } from 'client-app/pages/login';
import { LoginFinish } from 'client-app/pages/login-finish';
import { clientRouterPaths } from 'client-app/router/client-router-paths';
import type { IClientRoutes } from 'client-app/router/types';
import { useClientAuthStore } from 'client-app/stores/use-client-auth-store';

export const Router: React.FC = () => {
  const routes: IClientRoutes[] = [
    {
      path: clientRouterPaths.home,
      element: <ClientOrdersListPage />,
    },
  ];

  const { isAuth } = useClientAuthStore();

  return (
    <BrowserRouter>
      <Routes>
        {isAuth ? (
          <>
            <Route path={'/'} element={<GlobalLayout />}>
              {routes.map((route) => (
                <Route key={route.path} path={route.path} element={route.element} />
              ))}
            </Route>
            <Route path={'*'} element={<Navigate to={clientRouterPaths.home} replace />} />
          </>
        ) : (
          <>
            <Route path={clientRouterPaths.auth} element={<Login />} />
            <Route path={clientRouterPaths.authFinish} element={<LoginFinish />} />
            <Route path={'*'} element={<Navigate to={clientRouterPaths.auth} replace />} />
          </>
        )}
      </Routes>
    </BrowserRouter>
  );
};
